import DepsService from 'services/dependencies';

const RETAILER_DASHBOARD_CONTEXT = 'retailerDashboards';

export default function fetchRetailerId(retailerDisplayNumber) {
  const { url } = DepsService.rest.retailerDashboard.retailerId;
  const queryParams = {};
  const urlParams = { retailerDisplayNumber };

  return DepsService.restSrv.list(RETAILER_DASHBOARD_CONTEXT, url, queryParams, urlParams);
}



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/resources/retailer-dashboards-api.js